import { render } from "./BalBtn.vue?vue&type=template&id=7bc08a00&scoped=true&ts=true"
import script from "./BalBtn.vue?vue&type=script&lang=ts"
export * from "./BalBtn.vue?vue&type=script&lang=ts"

import "./BalBtn.vue?vue&type=style&index=0&id=7bc08a00&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc08a00"]])

export default __exports__